"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColorSwatch", {
    enumerable: true,
    get: function() {
        return ColorSwatch;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useColorSwatch = require("./useColorSwatch");
const _renderColorSwatch = require("./renderColorSwatch");
const _useColorSwatchStylesstyles = require("./useColorSwatchStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ColorSwatch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useColorSwatch.useColorSwatch_unstable)(props, ref);
    (0, _useColorSwatchStylesstyles.useColorSwatchStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useColorSwatchStyles_unstable')(state);
    return (0, _renderColorSwatch.renderColorSwatch_unstable)(state);
});
ColorSwatch.displayName = 'ColorSwatch';
